import { LightningElement, api, wire } from "lwc";
import createDOMPurify from "dompurify";

import { EffectAdapter } from "common/effectAdapter";

export type Config = Parameters<typeof purify.sanitize>[1];

const purify = createDOMPurify(window);

// https://github.com/cure53/DOMPurify/issues/317#issuecomment-728100494
purify.addHook("afterSanitizeAttributes", (node: Element) => {
  // set all elements owning target to target=_blank
  if (node.hasAttribute("target")) {
    node.setAttribute("target", "_blank");
    const prevRel = `${(node.getAttribute("rel") || "")
      .replace("noopener", "")
      .trim()}`;
    const rel = prevRel ? `noopener ${prevRel}` : "noopener";
    node.setAttribute("rel", rel);
  }
});

const defaultOptions: Config = {
  ADD_ATTR: ["target"],
  FORBID_TAGS: ["style"],
};

export default class extends LightningElement {
  @api html: string = "";
  @api config: Config = defaultOptions;

  private node = document.createElement("span");

  private get sanitizedHtml() {
    return purify.sanitize(this.html, this.config) as string;
  }

  @wire(EffectAdapter, { html: "$html" })
  private onHtml() {
    this.node.innerHTML = this.sanitizedHtml;
  }

  connectedCallback() {
    this.node.innerHTML = this.sanitizedHtml;
    this.template.host.append(this.node);
  }
}
